// Site-wide settings.
export const CONTACT_EMAIL = "hamdullah@rateguardnow.com";
export const SITE_URL = "https://rateguardnow.com";

export const PRICE = {
  tr: { main: "99 $", unit: "/ay", note: "otel başına · ≈ 4.999 TL" },
  en: { main: "$99", unit: "/month", note: "per hotel" },
  sr: { main: "99 €", unit: "/mesečno", note: "po hotelu" },
};
